import React from 'react'
import EpisodePlayScreen from './EpisodePlayScreen'
import SimilarSection from './SimilarSection'
import Footer from '../common/UI/Footer'
import { useParams } from 'react-router-dom'
import { useAudioBySlug } from '../hooks/useAudiosHooks'
import Loading from '../common/HousGlass Loader/Loading'

const EpisodeMain = () => {
  const { slug } = useParams()
  
  // Using the useAudioBySlug hook to fetch audio data based on slug
  const { data: audioData, isLoading, error } = useAudioBySlug(slug)
  
  // You can handle loading state here if needed
  if (isLoading) {
    return <div><Loading/></div>
  }
  
  // You can handle error state here if needed
  if (error) {
    return <div>Error loading episode</div>
  }
  
  return (
    <>
      <EpisodePlayScreen audioData={audioData} />
      <SimilarSection audioData={audioData} />
      <Footer />
    </>
  )
}

export default EpisodeMain